import React, {useState} from 'react';
import './testimonials.css'
import DharmendraImg from '../../assets/img/testimonials/Dharmendra_saini.jpg'
import Mannan from '../../assets/img/testimonials/Manan_bhalla.jpg'
import Nikhil from '../../assets/img/testimonials/Nikhil Sharma.jpg'
import Shalini from '../../assets/img/testimonials/Shalini_Kumari.jpg'
import Yogesh from '../../assets/img/testimonials/Yogesh.jpg'
import Bhargavi from '../../../assets/img/testimonials/Bhargavi_sharma.jpg'
import Kanishka from '../../../assets/img/testimonials/kanishka_singh.jpg'
import Parkhi from '../../../assets/img/testimonials/parkhi_gulati.jpg'
import Radhika from '../../../assets/img/testimonials/radhika.jpg'
import Harleen from '../../../assets/img/testimonials/Harleen_kaur.jpg'
import {Carousel} from "antd";

const testimonialsData = {
    french: [
        {
            "message": "I just want to give a shout out to Career Dose for all of their great work. When I started the course, I was feeling hopeless. But now that I've completed it, I feel like I'm on my way to an amazing career! What they offer is not only the best course in the market, but they have expert instructors and high-quality videos.",
            "person": "Dharmendra Saini",
            "profile": DharmendraImg
        },
        {
            "message": "Career Dose French Language Course is the best course in the market, hands down. In my opinion, it's worth every penny. I was really struggling with my career and realized I had to give myself a push when I found this course. Career Dose is filled with some of the best teachers and most practical advice out there",
            "person": "Mannan Bhalla",
            "profile": Mannan
        },
        {
            "message": "I've been looking for a course like this for the longest time. I finally found the one that is fulfilling my goal of becoming a certified expert in French. Career Dose offers excellent teachers and great videos with content that is not only relevant but also easy to understand. The syllabus covers all of the bases in an interactive and engaging manner.",
            "person": "Shalini Kumari",
            "profile": Shalini
        },
        {
            "message": "I have been watching Career Dose French Language Course  for a year now and it has been the BEST course that I have ever taken. The expert teachers are very knowledgeable in their field and the videos are top-quality. If someone wants to improve their career, this is the best course to buy.",
            "person": "Nikhil Sharma",
            "profile": Nikhil
        },
        {
            "message": "It's been a long time since I've felt this excited about a course. Career Dose does an incredible job of making the material easy to understand, and the content is fascinating! The videos are professionally done and it's always interesting to hear more from these experts that have been in the field for years.",
            "person": "Yogesh Thakur",
            "profile": Yogesh
        }
    ],
    abroad: [
        {
            message: 'I met with the staff at Career Dose Admissions Abroad and they were so helpful and informative. They gave me so many resources to help me find the perfect place abroad to study, but also gave me a clear picture of what I should expect. They are easy to talk too and their expertise really shows! I would definitely recommend them to anyone looking for an admissions consultancy',
            "person": "Bhargavi Sharma",
            "profile": Bhargavi
        },
        {
            message: 'I have been working with Career Dose for over a year now and all my international admissions queries have been solved with ease. They are the best admissions abroad consultants, counselors and have done an excellent job with helping me get my undergraduate degree from abroad. I\'m really happy with their service and can\'t thank them enough!',
            "person": "Kanishka Singh",
            "profile": Kanishka
        },
        {
            message: 'I studied abroad through Career Dose and had a great experience. The admissions team was very helpful, as well as the counselors who helped me prepare for all the applications. They made everything so easy. I would recommend them to anyone looking to study abroad!',
            "person": "Parkhi Gulati",
            "profile": Parkhi
        },
        {
            message: 'I was looking to go abroad for my MBA, but I had no idea where to start. Until my friend told me about Career Dose Admissions Abroad. They were awesome! They helped me with everything from choosing the right university, finding internships, and a great visa lawyer. They were efficient and got me into my dream school in Germany. I can\'t thank them enough',
            "person": "Radhika",
            "profile": Radhika
        },
        {
            message: 'I am a graduate of Career Dose. I always felt anxious about going abroad for college. Thankfully, my counselor at Career Dose was so patient and understanding. She walked me through the application process, helped me figure out which country to go to, and even help write my personal statement! I would not be where I am today had it not been for her assistance!',
            "person": "Harleen",
            "profile": Harleen
        },
        // {
        //     message:'Career Dose is the best when it comes to admissions abroad. I had to go through the process twice and they were always available to answer my questions and offer me sound advice on my journey. It was a very long, difficult process but they made it as painless as possible. I cannot recommend them enough!',
        //     person:'',
        //     profile:''
        // },
    ]
}

function TestimonialsSection(props) {
    return (
        <>
            <h1 className="font-weight-bold text-center cd-green-text pt-4 pt-sm-2">Testimonials</h1>
            <Carousel autoplay>
                {
                    testimonialsData[props.type].map((item, index) => {
                        return <div className={'d-flex flex-column align-items-center text-center gap-1 py-5 pt-3'} key={index}>
                            <span className={'text-muted testimonial-message'}>{item.message}</span>
                            <img src={item.profile} className="profile-img rounded-circle mt-2"/>
                            <span className={'font-weight-bold'}>{item.person}</span>
                        </div>
                    })
                }
            </Carousel>
        </>
    )
}


export default TestimonialsSection;
